import classNames from 'classnames'
import * as React from 'react'

import {getComparisons} from '@/../lib/storyblok/helpers'
import {makeEditable} from '@/common/utils'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'

import {ComparisonLogo, isWitik} from '../helpers'

const ComparisonLinks = ({_editable, story, witik, headingTag, heading}) => {
  const HeadingTag = headingTag || 'p'

  const hasSolutions =
    story.comparison_database &&
    Array.isArray(story.comparison_database.solutions) &&
    story.comparison_database.solutions.length > 0

  if (hasSolutions) {
    const comparisons = getComparisons(story.comparison_database.solutions)

    return (
      <section {...makeEditable(_editable)} className='py-16 md:py-24'>
        <Grid className='gap-y-12'>
          <HeadingTag className='col-span-full text-center'>
            <Heading heading={heading} size='xs' className='block' />
          </HeadingTag>
          <ul className='col-span-full grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-8 lg:grid-cols-4'>
            {comparisons.map(({slug, names}, index) => {
              if (names.some(isWitik) !== witik) return null

              return (
                <li
                  key={index}
                  className='body-l-bold rounded-2xl bg-violet-300 text-purple-900 hover:bg-violet-400'
                >
                  <a
                    href={`/${slug.main}/`}
                    className='flex flex-col overflow-hidden rounded-2xl focus:outline focus:outline-2 focus:outline-violet-600'
                  >
                    <Card name={names[0]} />
                    <span className='h-0 -translate-y-1/2'>
                      <span className='body-s-bold mx-auto block w-fit -translate-y-1/2 rounded-xl bg-yellow-400 px-2 py-1 text-center'>
                        VS
                      </span>
                    </span>
                    <Card name={names[1]} />
                  </a>
                </li>
              )
            })}
          </ul>
        </Grid>
      </section>
    )
  }

  return null
}

const Card = ({name}) => {
  const witik = isWitik(name)
  return (
    <span
      className={classNames('px-1 py-6 text-center md:py-8', {
        'rounded-2xl bg-violet-600': witik,
      })}
    >
      {witik ? <ComparisonLogo /> : name}
    </span>
  )
}

export default ComparisonLinks
